<template>
  <div
    v-if="applyDocument.id"
  >
    <b-card>
      <b-row>
        <div class="col-md-6">
          <table class="table table-bordered">
            <tr>
              <th>{{ $t('Dc Type') }}</th>
              <td> {{ $langName(getDcType(applyDocument.dc_type).name) }}</td>
            </tr>
            <tr>
              <th>{{ $t('Applicant') }}</th>
              <td> {{ applyDocument.user.full_name }}</td>
            </tr>
            <tr>
              <th>{{ $t('Organization') }}</th>
              <td> {{ $langName(applyDocument.organization.name) }}</td>
            </tr>
            <tr>
              <th>{{ $t('Quarter') }}</th>
              <td> {{ applyDocument.quarter.period.admission_year + '/'+ applyDocument.quarter.quarter }}</td>
            </tr>
            <tr v-if="isStatusRejected()">
              <th>{{ $t('Comment') }}</th>
              <td>
                <b-badge
                  variant="danger"
                  class="text-left"
                  style="white-space: normal; line-height: 1.4"
                >
                  {{ applyDocument.rejected_info }}
                </b-badge>
              </td>
            </tr>
            <tr>
              <th>{{ $t('Mobile phone') }}</th>
              <th>{{ applyDocument.user.mob_phone_no }}</th>
            </tr>
            <tr>
              <th>{{ $t('Education Language') }}</th>
              <td> {{ $langName(getEduLang(applyDocument.edu_lang).name) }}</td>
            </tr>
            <tr>
              <th>{{ $t('Direction') }}</th>
              <td> {{ applyDocument.direction.code + " - " + $langName(applyDocument.direction.name) }}</td>
            </tr>
            <tr>
              <th>{{ $t('View time') }}</th>
              <th v-if="applyDocument.view_time">
                {{ (new Date(applyDocument.view_time)).toLocaleDateString() }} {{ (new Date(applyDocument.view_time)).toLocaleTimeString() }}
              </th>
            </tr>
            <tr>
              <th>{{ $t('Applied time') }}</th>
              <th v-if="applyDocument.applied_time">
                {{ (new Date(applyDocument.applied_time)).toLocaleDateString() }} {{ (new Date(applyDocument.applied_time)).toLocaleTimeString() }}
              </th>
            </tr>
          </table>
        </div>
        <div class="col-md-6">
          <table class="table table-bordered">
            <tr v-if="applyDocument.direction_second">
              <th>{{ $t('Second direction') }}</th>
              <td> {{ applyDocument.direction_second.code + " - " + $langName(applyDocument.direction_second.name) }}</td>
            </tr>
            <tr>
              <th>{{ $t('Scientific work name') }} </th>
              <td>
                <b-badge
                  v-if="applyDocument.scientific_work_name"
                  :variant="getApplyDocumentStatusColor(200)"
                  style="white-space: normal"
                >

                  {{ applyDocument.scientific_work_name }}
                </b-badge>
                <b-badge
                  v-else
                  :variant="getApplyDocumentStatusColor(300)"
                  style="white-space: normal"
                >
                  {{ $t('This place is filled by a higher education institution or scientific organization') }}
                </b-badge>
              </td>
            </tr>
            <tr>
              <th>
                {{ $t('Scientific advisor/consultant') }}
              </th>
              <td>
                <b-badge
                  v-if="applyDocument.advisor"
                  :variant="getApplyDocumentStatusColor(200)"
                  style="white-space: normal"
                >
                  {{ applyDocument.advisor.full_name }}
                </b-badge>
                <b-badge
                  v-else
                  :variant="getApplyDocumentStatusColor(300)"
                  style="white-space: normal"
                >
                  {{ $t('This place is filled by a higher education institution or scientific organization') }}
                </b-badge>
              </td>
            </tr>
            <tr>
              <th>{{ $t('PNFL') }}</th>
              <td>
                <b-badge :variant="getApplyDocumentStatusColor(100)">
                  {{ applyDocument.user.pin }}
                </b-badge>
              </td>
            </tr>
            <tr>
              <th>{{ $t('Status') }}</th>
              <td>
                <b-badge :variant="getApplyDocumentStatusColor(applyDocument.status)">
                  {{ $langName(getApplyDocumentStatus(applyDocument.status).name) }}
                </b-badge>
              </td>
            </tr>
            <tr v-if="applyDocument.diplom_json">
              <th>{{ $t('Diploma') }}</th>
              <td>
                <show-diplom-modal-component :diploma="applyDocument.diplom_json" />
              </td>
            </tr>
            <tr v-if="applyDocument.diplom_bachelor_json">
              <th>{{ $t('Bachelor diplom') }}</th>
              <td>
                <show-diplom-modal-component
                  modal-id="show-diplom-bachelor"
                  :diploma="applyDocument.diplom_bachelor_json"
                />
              </td>
            </tr>
            <tr v-if="getWorkbooks()">
              <th>{{ $t('Workbook') }}</th>
              <td>
                <show-workbook-modal-component :workbooks="getWorkbooks()" />
              </td>
            </tr>
            <tr v-if="applyDocument.banned_file">
              <th colspan="2">
                <a
                  :href="applyDocument.banned_file"
                  download
                  target="_blank"
                >{{ $t('Banned File') }}</a>
              </th>
            </tr>
            <tr v-if="applyDocument.phd_diplom">
              <th colspan="2">
                <a
                  :href="applyDocument.phd_diplom"
                  download
                  target="_blank"
                >{{ $t('Phd Diplom') }}</a>
              </th>
            </tr>
            <tr v-if="applyDocument.dsc_diplom">
              <th colspan="2">
                <a
                  :href="applyDocument.dsc_diplom"
                  download
                  target="_blank"
                >{{ $t('Dsc Diplom') }}</a>
              </th>
            </tr>
            <tr>
              <th>Passport integratsiyasi</th>
              <td><show-passport-modal-component :user="applyDocument.user" /></td>
            </tr>
            <tr>
              <th>Nogironlik guvohnomasi</th>
              <td>
                <show-disability-data-component :data="applyDocument.disability_data" />
              </td>
            </tr>
            <tr>
              <th>{{ $t('Course') }}</th>
              <td>{{ applyDocument.course }}</td>
            </tr>
            <tr v-if="applyDocument.old_apply_doc_file">
              <th colspan="2">
                <b-link
                  :href="applyDocument.old_apply_doc_file"
                  download="file"
                  target="_blank"
                >
                  {{ $t('File') }}
                  <feather-icon
                    icon="DownloadIcon"
                    class="cursor-pointer"
                    size="16"
                  />
                </b-link>
              </th>
            </tr>
            <tr>
              <th>{{ $t('Certificate') }}</th>
              <td>{{ getCertificateName(applyDocument) }}</td>
            </tr>
          </table>
        </div>
      </b-row>

      <section
        v-if="isInno"
        class="apply-document-history mx-auto mt-2 mb-2"
      >
        <div class="text-center mb-1">
          <h3 class="mb-25">
            {{ $t('Application history') }}
          </h3>
          <small class="text-muted">{{ applyDocument.user.full_name }}</small>
        </div>

        <div
          v-if="isHistoryBusy"
          class="text-center py-2"
        >
          <b-spinner variant="primary" />
        </div>
        <b-table
          v-else
          responsive
          hover
          striped
          show-empty
          :empty-text="$t('No applications found')"
          :items="applyDocumentHistory"
          :fields="historyFields"
          class="mb-0"
        >
          <template #cell(application)="data">
            <span class="font-weight-bold">#{{ data.item.id }}</span>
            <b-badge
              v-if="data.item.id === applyDocument.id"
              variant="light-primary"
              class="ml-50"
            >
              {{ $t('Current application') }}
            </b-badge>
          </template>
          <template #cell(applied_time)="data">
            {{ formatDateTime(data.item.applied_time) }}
          </template>
          <template #cell(quarter)="data">
            {{ getQuarterLabel(data.item.quarter) }}
          </template>
          <template #cell(direction)="data">
            <span v-if="data.item.direction">
              {{ data.item.direction.code }} - {{ $langName(data.item.direction.name) }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="getApplyDocumentStatusColor(data.item.status)">
              {{ $langName(getApplyDocumentStatus(data.item.status).name) }}
            </b-badge>
          </template>
          <template #cell(organization)="data">
            {{ data.item.organization ? $langName(data.item.organization.name) : '-' }}
          </template>
          <template #cell(dc_type)="data">
            {{ $langName(getDcType(data.item.dc_type).name) }}
          </template>
        </b-table>
      </section>
      <hr>
      <validation-observer ref="sendApplyDocument">
        <b-row>
          <div class="col-md-6">
            <upload-file
              field="bio_uz"
              label="Bio Uz"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>

          <div
            v-if="!getWorkbooks()"
            class="col-md-6"
          >
            <upload-file
              field="workbook"
              label="Workbook"
              rules="file-size:5"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div
            class="col-md-6"
          >
            <upload-file
              field="diploma"
              label="Diploma"
              rules="file-size:5"
              not-required="Not mandatory if diploma data"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div
            class="col-md-6"
          >
            <upload-file
              field="diploma_bachelor"
              label="Bachelor diplom"
              not-required="Not mandatory if diploma data"
              rules="file-size:5"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div
            v-if="isDc()"
            class="col-md-6"
          >
            <upload-file
              field="scientific_project"
              label="Scientific project"
              :rules="getScientificProjectRules()"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div
            v-if="requiresResearchPresentation()"
            class="col-md-6"
          >
            <upload-file
              field="research_presentation"
              label="Ilmiy tadqiqot ishi taqdimoti"
              rules="required|file-size:5"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div class="col-md-6">
            <upload-file
              field="government_award"
              label="Government award"
              rules="file-size:5"
              :apply-document="applyDocument"
              :frozen="!canUpdate(applyDocument)"
            />
          </div>
          <div class="col-md-6">
            <upload-file
              field="language_certificate"
              label="Language certificate"
              :rules="getLanguageCertificateRules()"
              :apply-document="applyDocument"
            />
          </div>
          <div
            v-if="applyDocument.benefit_type && applyDocument.benefit_type !== NO_BENEFIT_TYPE"
            class="col-md-6"
          >
            <upload-file
              field="benefit_file"
              label="Privilege document"
              :apply-document="applyDocument"
            />
          </div>
          <div class="col-md-6">
            <upload-file
              field="subject_certificate_file"
              label="Subject Certificate File"
              rules="file-size:5"
              :apply-document="applyDocument"
            />
          </div>
        </b-row>
      </validation-observer>
    </b-card>
    <h3 class="text-center">
      {{ $t('Scientific articles and theses') }}
    </h3>
    <scientific-work />
    <b-card>
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-end align-items-end"
        >
          <b-button
            v-if="!isInno && !isOtm && canSend(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="ml-1"
            @click="submit"
          >
            {{ $t('Send') }}
          </b-button>

          <b-button
            v-if="!isInno && isOtm && canAccept(applyDocument)"
            v-b-toggle.sidebar-accept-rejected-doc
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="ml-1"
          >
            {{ $t('Accepted') }}
          </b-button>

          <b-button
            v-if="!isInno && isOtm && canReject(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-reject-apply-document
            variant="danger"
            class="ml-1"
          >
            {{ $t('Rejected') }}
          </b-button>

          <b-button
            v-if="!isInno && !isOtm && canRegenerate(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="ml-1"
            @click="regenerate"
          >
            {{ $t('Regenerate') }}
          </b-button>
          <b-button
            v-if="!isInno && isOtm && canCancelStudent(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-cancel-student
            variant="danger"
            class="ml-1"
          >
            {{ $t('Cancel Student') }}
          </b-button>
          <b-button
            v-if="!isInno && isOtm && canFinishStudent(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-finish-student
            variant="success"
            class="ml-1"
          >
            {{ $t('Finish Student') }}
          </b-button>
          <b-button
            v-if="!isInno && isOtm && canVacation(applyDocument)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-vacation-apply-document
            variant="success"
            class="ml-1"
          >
            {{ $t(applyDocument.status === applyDocumentOnAcademicLeave ? 'Return from vacation': 'Vacation') }}
          </b-button>

        </b-col>
      </b-row>
    </b-card>
    <rejected @refetchData="refetchData" />
    <accept-rejected-doc @refetchData="refetchData" />
    <cancel-student @refetchData="refetchData" />
    <finish-student @refetchData="refetchData" />
    <vacation @refetchData="refetchData" />
  </div>
  <div
    v-else
    class="d-flex justify-content-center"
  >
    <b-spinner
      key="primary"
      variant="primary"
    />
  </div>
</template>

<script>
import {
  BBadge, BButton, BCard, BCol, BLink, BRow, BSpinner, BTable, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { localize, ValidationObserver } from 'vee-validate'
import applyDocumentModule from '@/store/apply-document/index'
import store from '@/store'
import permission from './permission'
import UploadFile from './UploadFile.vue'
import ScientificWork from './scientific-work/ScientificWork.vue'
import Rejected from './Rejected.vue'
import ShowDiplomModalComponent from '@/views/components/ShowDiplomModalComponent.vue'
import ShowWorkbookModalComponent from '@/views/components/ShowWorkbookModalComponent.vue'
import AcceptRejectedDoc from '@/views/pages/apply-document/AcceptRejectedDoc.vue'
import CancelStudent from '@/views/pages/apply-document/CancelStudent.vue'
import FinishStudent from '@/views/pages/apply-document/FinishStudent.vue'
import Vacation from '@/views/pages/apply-document/Vacation.vue'
import { getUserData } from '@/auth/utils'
import ShowPassportModalComponent from '@/views/pages/apply-document/components/show-passport-data.vue'
import { CertificateDegreeList } from '@/classes/CertificateDegrees'
import { TypeBenefits, TypeBenefitsList } from '@/classes/TypeBenefits'
import ShowDisabilityDataComponent from '@/views/pages/apply-document/components/ShowDisabilityData.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  components: {
    ShowDisabilityDataComponent,
    BLink,
    ShowPassportModalComponent,
    Vacation,
    FinishStudent,
    CancelStudent,
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BSpinner,
    BTable,
    UploadFile,
    ValidationObserver,
    ScientificWork,
    Rejected,
    ShowDiplomModalComponent,
    ShowWorkbookModalComponent,
    AcceptRejectedDoc,
  },
  data() {
    return {
      isOtm: false,
      isInno: false,
      isHistoryBusy: false,
    }
  },
  computed: {
    applyDocument() {
      return this.$store.state[this.MODULE_NAME].applyDocument
    },
    applyDocumentHistory() {
      return this.$store.state[this.MODULE_NAME].applyDocumentHistory
    },
    historyFields() {
      return [
        { key: 'application', label: this.$t('Application'), class: 'text-center' },
        { key: 'applied_time', label: this.$t('Submitted time'), class: 'text-center' },
        { key: 'quarter', label: this.$t('Year / quarter'), class: 'text-center' },
        { key: 'direction', label: this.$t('Direction') },
        { key: 'status', label: this.$t('Status'), class: 'text-center' },
        { key: 'organization', label: this.$t('Organization') },
        { key: 'dc_type', label: this.$t('Dc Type'), class: 'text-center' },
      ]
    },
  },
  created() {
    this.isOtm = this.$route.meta.isOtm
    this.isInno = this.$route.meta.isInno
    localize(this.$i18n.locale)
    this.refetchData()
  },
  methods: {
    formatDateTime(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return '-'
      return date.toLocaleString(this.$i18n.locale)
    },
    getQuarterLabel(quarter) {
      if (!quarter) return '-'
      const year = quarter.period ? quarter.period.admission_year : '-'
      return `${year} / ${quarter.quarter}`
    },
    isDc() {
      return this.$store.getters['staticModule/isDc'](this.applyDocument.dc_type)
    },
    requiresResearchPresentation() {
      const scholarshipTypes = [this.DSc, this.PhD, this.targetedDSc, this.targetedPhD]
      return Boolean(this.applyDocument.direction?.is_priority)
        && scholarshipTypes.includes(this.applyDocument.dc_type)
    },
    getLanguageCertificateRules() {
      const dcTypes = [this.traineeResearcher, this.independentResearcherPhD, this.independentResearcherDSc]
      if (dcTypes.includes(this.applyDocument.dc_type) || (this.applyDocument.benefit_type && this.applyDocument.benefit_type !== this.NO_BENEFIT_TYPE)) {
        return 'file-size:5'
      }
      return 'required|file-size:5'
    },
    getWorkPlaceRules() {
      const dcTypes = [this.independentResearcherPhD, this.independentResearcherDSc]
      if (dcTypes.includes(this.applyDocument.dc_type)) {
        return 'required|file-size:5'
      }
      return 'file-size:5'
    },
    getScientificProjectRules() {
      const dcTypes = [this.independentResearcherPhD, this.independentResearcherDSc]
      if (dcTypes.includes(this.applyDocument.dc_type)) {
        return 'file-size:5'
      }
      return 'required|file-size:5'
    },
    getWorkbooks() {
      if (this.applyDocument.my_mehnat_json && this.applyDocument.my_mehnat_json.experiences) {
        return this.applyDocument.my_mehnat_json.experiences
      }
      return null
    },
    isStatusRejected() {
      return this.applyDocument.status === this.$store.state.staticModule.applyDocumentStatusRejected
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getEduLang(id) {
      return this.$store.getters['staticModule/getEduLangType'](id)
    },
    getApplyDocumentStatus(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatus'](id)
    },
    getApplyDocumentStatusColor(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatusColor'](id)
    },
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id)
      if (this.isInno) {
        this.isHistoryBusy = true
        this.$store.dispatch(`${this.MODULE_NAME}/history`, this.$route.params.id)
          .catch(() => {
            this.$store.commit(`${this.MODULE_NAME}/HISTORY`, [])
          })
          .finally(() => {
            this.isHistoryBusy = false
          })
      }
    },
    submit() {
      this.$refs.sendApplyDocument.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.applyDocument.id,
            body: {
              status: this.$store.state.staticModule.applyDocumentStatusPending,
            },
          }, `${this.MODULE_NAME}/patch`, () => {
            this.refetchData()
          }, {
            text: '',
            confirmButtonText: 'Yes, send it!',
            successTitle: 'Send!',
            successText: 'Your file has been sent.',
            errorText: 'Your file has not been sent.',
          })
        }
      })
    },
    regenerate() {
      this.$removeSwal(
        this,
        this.applyDocument.id,
        `${this.MODULE_NAME}/regenerate`,
        res => {
          this.$router.push({ name: 'apply-document-view', params: { id: res.id } })
          this.refetchData()
        },
        {
          confirmButtonText: 'Yes, regenerate it!',
          successTitle: 'Regenerated!',
          successText: 'Your file has been regenerated.',
          errorText: 'Your file has not been regenerated.',
        },
      )
    },
    admitted() {
      this.$removeSwal(this, {
        id: this.applyDocument.id,
        body: {
          status: this.$store.state.staticModule.applyDocumentAdmittedToStudy,
        },
      }, `${this.MODULE_NAME}/patch`, this.refetchData, {
        confirmButtonText: 'Yes, admit it!',
        successTitle: 'Admitted!',
        successText: 'This student has been admitted.',
        errorText: 'This student has not been admitted.',
      })
    },
    failed() {
      this.$removeSwal(this, {
        id: this.applyDocument.id,
        body: {
          status: this.$store.state.staticModule.applyDocumentFailedInExam,
        },
      }, `${this.MODULE_NAME}/patch`, this.refetchData, {
        confirmButtonText: 'Yes, fail exam!',
        successTitle: 'Failed Exam!',
        successText: 'Successfully completed.',
        errorText: 'There was an error in successful execution.',
      })
    },
    getCertificateName(data) {
      const arr = []
      if (data.certificate_type) {
        if (data.certificate_type.certificate_lang) {
          arr.push(this.$langName(data.certificate_type.certificate_lang))
        }
        arr.push(data.certificate_type.name)
      }
      if (data.certificate_degree) {
        const find = CertificateDegreeList.find(degree => degree.id === data.certificate_degree)
        if (find) {
          arr.push(find.name)
        }
      }
      return arr.join(', ')
    },
  },
  setup() {
    const MODULE_NAME = 'applyDocument'
    const {
      traineeResearcher, independentResearcherDSc, independentResearcherPhD,
      DSc, PhD, targetedDSc, targetedPhD,
    } = store.state.staticModule
    const { applyDocumentOnAcademicLeave } = store.state.staticModule
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, applyDocumentModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    const userData = getUserData()
    const { NO_BENEFIT_TYPE } = TypeBenefits
    const benefitTypeList = TypeBenefitsList
    return {
      MODULE_NAME,
      traineeResearcher,
      independentResearcherDSc,
      independentResearcherPhD,
      DSc,
      PhD,
      targetedDSc,
      targetedPhD,
      applyDocumentOnAcademicLeave,
      userData,
      ...permission(),
      NO_BENEFIT_TYPE,
      benefitTypeList,
    }
  },
}
</script>

<style lang="scss" scoped>
.apply-document-history {
  max-width: 1180px;
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
  padding: 1.5rem;
  background: #fff;
}
</style>
